




























import Vue from 'vue';

// Services
import AonContext, { InstrumentData, InstrumentStatus } from '~/services/AonContext';

// Components

// Constants
const STATUS_ICON = {
    [InstrumentStatus.UNKNOWN]: 'check-circle',
    [InstrumentStatus.INCOMPLETE]: 'check-circle',
    [InstrumentStatus.NEW]: 'check-circle',
    [InstrumentStatus.IN_PROGRESS]: 'hourglass',
    [InstrumentStatus.PROCESSING]: 'hourglass',
    [InstrumentStatus.COMPLETE]: 'check-circle',
    [InstrumentStatus.BLOCKED]: 'stop',
};

const STATUS_COLOR = {
    [InstrumentStatus.UNKNOWN]: 'rgba(0,0,0,0.1)',
    [InstrumentStatus.INCOMPLETE]: 'rgba(0,0,0,0.1)',
    [InstrumentStatus.NEW]: 'rgba(0,0,0,0.1)',
    [InstrumentStatus.IN_PROGRESS]: 'var(--pending)',
    [InstrumentStatus.PROCESSING]: 'var(--pending)',
    [InstrumentStatus.COMPLETE]: '#10B981',
    [InstrumentStatus.BLOCKED]: 'var(--error)',
};

export default Vue.extend({
    name: 'AssessmentList',
    props: {
        instr: {
            type: Object as () => InstrumentData,
            default: () => ({} as InstrumentData),
        },
        showProgress: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            statusIcon: STATUS_ICON,
            statusColor: STATUS_COLOR,
        };
    },
});
